import React, { useEffect } from 'react';
const TaboolaFeed = _ref => {
  let {
    config
  } = _ref;
  useEffect(() => {
    window._taboola.push({
      article: 'auto',
      url: window.location.href
    });
    window._taboola.push({
      mode: 'alternating-thumbnails-a',
      container: config.containerId,
      placement: config.placement,
      target_type: 'mix'
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: config.containerId,
    "data-sentry-component": "TaboolaFeed",
    "data-sentry-source-file": "TaboolaFeed.tsx"
  });
};
export default TaboolaFeed;